(function () {
  function initHero(root) {
    const track = root.querySelector('[data-swm26-hero-track]');
    const bulletsWrap = root.querySelector('[data-swm26-hero-bullets]');
    if (!track || !bulletsWrap) return;

    let slides = Array.from(root.querySelectorAll('[data-swm26-hero-slide]'));
    const realCount = slides.length;
    if (realCount <= 1) return;

    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

    // --- Build infinite loop (clone last + first)
    const firstReal = slides[0];
    const lastReal = slides[realCount - 1];

    const firstClone = firstReal.cloneNode(true);
    const lastClone = lastReal.cloneNode(true);

    firstClone.setAttribute('data-swm26-clone', 'true');
    lastClone.setAttribute('data-swm26-clone', 'true');

    track.insertBefore(lastClone, firstReal);
    track.appendChild(firstClone);

    // refresh list after cloning
    slides = Array.from(track.children);
    const totalCount = slides.length; // realCount + 2

    // internalIndex points to track children (includes clones)
    // start at 1 = first real slide
    let internalIndex = 1;
    let realIndex = 0;

    let autoTimer = null;
    let isAnimating = false;

    // --- Bullets
    bulletsWrap.innerHTML = '';
    const bullets = Array.from({ length: realCount }).map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'swm26-hero__bullet';
      b.setAttribute('aria-label', `Slide ${i + 1}`);
      b.addEventListener('click', () => {
        goToReal(i, true);
        restartAutoplay();
      });
      bulletsWrap.appendChild(b);
      return b;
    });

    function updateBullets() {
      bullets.forEach((b, i) => b.setAttribute('aria-current', i === realIndex ? 'true' : 'false'));
    }

    function slideWidth() {
      return root.getBoundingClientRect().width;
    }

    function setTranslateByInternal(idx, animate) {
      const x = -idx * slideWidth();
      track.style.transition = animate ? 'transform 900ms ease' : 'none';
      track.style.transform = `translate3d(${x}px,0,0)`;
    }

    function syncRealIndex() {
      // internalIndex 1..realCount corresponds to real 0..realCount-1
      realIndex = internalIndex - 1;
      if (realIndex < 0) realIndex = realCount - 1;
      if (realIndex > realCount - 1) realIndex = 0;
      updateBullets();
    }

    function goToInternal(nextInternal, animate) {
      if (isAnimating && animate) return;
      internalIndex = nextInternal;
      isAnimating = !!animate;
      setTranslateByInternal(internalIndex, animate);
      syncRealIndex();
    }

    function goToReal(nextReal, animate) {
      // real 0..realCount-1 maps to internal 1..realCount
      const nextInternal = nextReal + 1;
      goToInternal(nextInternal, animate);
    }

    function next() {
      goToInternal(internalIndex + 1, true);
    }

    function prev() {
      goToInternal(internalIndex - 1, true);
    }

    // --- After transition: handle wrap jump (unlimited)
    track.addEventListener('transitionend', () => {
      if (!isAnimating) return;
      isAnimating = false;

      // if we are on the clone after last real (index = realCount + 1)
      if (internalIndex === realCount + 1) {
        internalIndex = 1;
        setTranslateByInternal(internalIndex, false);
        syncRealIndex();
        return;
      }

      // if we are on the clone before first real (index = 0)
      if (internalIndex === 0) {
        internalIndex = realCount;
        setTranslateByInternal(internalIndex, false);
        syncRealIndex();
      }
    });

    // --- Autoplay
    function startAutoplay() {
      stopAutoplay();
      autoTimer = setInterval(next, 5000);
    }

    function stopAutoplay() {
      if (autoTimer) clearInterval(autoTimer);
      autoTimer = null;
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    // --- Mobile swipe only
    if (isTouchDevice) {
      let dragging = false;
      let startX = 0;
      let currentX = 0;
      let baseX = 0;

      function pointerDown(e) {
        if (!e.isPrimary) return;
        dragging = true;
        startX = e.clientX;
        currentX = startX;
        baseX = -internalIndex * slideWidth();
        track.style.transition = 'none';
      }

      function pointerMove(e) {
        if (!dragging) return;
        currentX = e.clientX;
        const delta = currentX - startX;
        track.style.transform = `translate3d(${baseX + delta}px,0,0)`;
      }

      function pointerUp(e) {
        if (!dragging) return;
        dragging = false;

        const delta = (typeof e.clientX === 'number' ? e.clientX : currentX) - startX;
        const threshold = slideWidth() * 0.12;

        if (delta > threshold) prev();
        else if (delta < -threshold) next();
        else goToInternal(internalIndex, true);

        restartAutoplay();
      }

      track.addEventListener('pointerdown', pointerDown);
      track.addEventListener('pointermove', pointerMove);
      track.addEventListener('pointerup', pointerUp);
      track.addEventListener('pointercancel', pointerUp);
    }

    // --- Resize
    window.addEventListener('resize', () => {
      setTranslateByInternal(internalIndex, false);
    });

    // --- Init: jump to first real
    setTranslateByInternal(internalIndex, false);
    syncRealIndex();
    startAutoplay();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-swm26-hero]').forEach(initHero);
  });
})();